import { Component, Inject, OnDestroy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { NavigationStart, Router } from '@angular/router'
import { Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'

@Component({
  selector: 'app-search-dialog',
  templateUrl: './search-dialog.component.html',
  styleUrls: ['./search-dialog.component.css'],
})
export class SearchDialogComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { searchText: string | null } | null,
    private dialogRef: MatDialogRef<SearchDialogComponent>,
    private router: Router,
  ) {
    // Close the dialog if the user navigates away (e.g. by clicking a link inside a result card).
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.dialogRef.close())
  }

  close(): void {
    this.dialogRef.close()
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
